import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'ghost', children, style, disabled, className, ...rest },
  ref,
) {
  // Geometry here; colour, border, the disabled state and the press feedback
  // per variant live in styles/glass.css (`.rt-btn--…`), one rule per skin.
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    minHeight: 36,
    padding: '9px 15px',
    fontWeight: 600,
    fontSize: 13.5,
    cursor: disabled ? 'not-allowed' : 'pointer',
  } as const;

  return (
    <button
      {...rest}
      ref={ref}
      disabled={disabled}
      className={[`rt-btn rt-btn--${variant}`, className].filter(Boolean).join(' ')}
      style={{ ...base, ...style }}
    >
      {children}
    </button>
  );
});
